import {Routes, RouterModule} from '@angular/router';
import {SourcesComponent} from './components/sources/sources.component';
import {MainComponent} from './components/main/main.component';
import {ManagementComponent} from './components/management/management.component';
import {NewSimulationComponent} from './components/new-simulation/new-simulation.component';
import {ProductInformationComponent} from './components/new-simulation/product-information/product-information.component';
import {MeaSelectionComponent} from './components/new-simulation/mea-selection/mea-selection.component';
import {TenderSelectionComponent} from './components/new-simulation/tender-selection/tender-selection.component';
import {SimulationInputComponent} from './components/new-simulation/simulation-input/simulation-input.component';
import {TenderSimulationInputComponent} from './components/new-simulation/tender-simulation-input/tender-simulation-input.component';
import {SimulationResultComponent} from './components/new-simulation/simulation-result/simulation-result.component';
import {TenderSimulationResultComponent} from './components/new-simulation/tender-simulation-result/tender-simulation-result.component';
import {SimulationListComponent} from './components/simulation-list/simulation-list.component'
import {ModuleWithProviders} from '@angular/core';
import {AuthService} from './services/auth.service';
import {SavedSimulationComponent} from './components/saved-simulation/saved-simulation.component';

const routes: Routes = [{
    canActivate: [AuthService],
    path: '',
    component: MainComponent
},
    {
        canActivate: [AuthService],
        path: 'login/:user/:token',
        component: MainComponent
    },
    {
        path: 'management',
        component: ManagementComponent,
    },
    {
        canActivate: [AuthService],
        path: 'simulation-list',
        component: SimulationListComponent,
    },
    {
        path : 'saved-simulation',
        component: SavedSimulationComponent
    },
    {
        canActivate: [AuthService],
        path: 'new-simulation',
        component: NewSimulationComponent,
        children: [
            {
                path: '',
                redirectTo: 'product-information',
                pathMatch: 'full'
            },
            {
                path: 'product-information',
                component: ProductInformationComponent
            },
            {
                path: 'mea-selection',
                component: MeaSelectionComponent
            },
            {
                path: 'tender-selection',
                component: TenderSelectionComponent
            },
            {
                path: 'simulation-input',
                component: SimulationInputComponent
            },
            {
                path: 'tender-simulation-input',
                component: TenderSimulationInputComponent
            },
            {
                path: 'simulation-result',
                component: SimulationResultComponent
            },
            {
                path: 'tender-simulation-result',
                component: TenderSimulationResultComponent
            }
        ]
    },
    {
        path: 'sources',
        component: SourcesComponent
    }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/app.routes.ts